import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../_model/user';
import { map } from 'rxjs/operators';
import { baseUrl } from './url';
import { Router } from '@angular/router';
@Injectable({
  providedIn: "root"
})
export class AuthenticationService {
  private isloggedIn: boolean;
  baseUrl = baseUrl;
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(private http: HttpClient, private route: Router) {
    this.currentUserSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) {
    const data = { ros_email: username, ros_password: password };
    return this.http.post<any>(this.baseUrl + "ros_login.php", data).pipe(
      map(user => {
        this.isloggedIn = true;
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("currentUser", JSON.stringify(user));
        this.currentUserSubject.next(user);
        // this.route.navigate([this.returnUrl]);
        return user;
        // return of(this.isloggedIn);
      })
    );
  }
  isUserLoggedIn(): boolean {
    return this.isloggedIn;
  }
  logout() {
             // remove user from local storage to log user out
             this.isloggedIn = false;
             localStorage.removeItem("currentUser");
             this.route.navigate(["/home"]);
             this.currentUserSubject.next(null);
           }
}
